module.exports = __webpack_public_path__ + "img/ico_delivery_gift.dc732c8.svg";